/**
 * Mobile Menu Component
 *
 * Slide-in drawer menu with accordion support for nested links.
 * Uses Alpine Focus plugin for scroll lock and keyboard navigation.
 *
 * Usage in Liquid:
 * <div x-data="mobileMenu">
 *   <button @click="toggle">Menu</button>
 *   <div x-show="open" @click="close"></div>
 *   <div x-show="open" x-trap.inert.noscroll="open">
 *     <template x-for="(item, index) in items">
 *       <button @click="toggleSubmenu(index)">{{ item.title }}</button>
 *       <div x-show="activeSubmenu === index" x-collapse>
 *         <!-- submenu items -->
 *       </div>
 *     </template>
 *   </div>
 * </div>
 */

import type { Magics } from 'alpinejs';

interface MobileMenuData {
    open: boolean;
    activeSubmenu: number | null;
    toggle(this: MobileMenuContext): void;
    close(this: MobileMenuContext): void;
    toggleSubmenu(this: MobileMenuContext, index: number): void;
}

type MobileMenuContext = MobileMenuData & Magics<MobileMenuData>;

export default function mobileMenu() {
    return {
        open: false,
        activeSubmenu: null,

        toggle() {
            this.open = !this.open;
            if (!this.open) {
                this.activeSubmenu = null;
            }
        },

        close() {
            this.open = false;
            this.activeSubmenu = null;
        },

        toggleSubmenu(index) {
            if (this.activeSubmenu === index) {
                this.activeSubmenu = null;
            } else {
                this.activeSubmenu = index;
            }
        },
    } as MobileMenuData;
}
